// extracted by mini-css-extract-plugin
export var activeFilterButton = "_qr-c";
export var backButton = "_qr-4";
export var backIcon = "_qr-5";
export var chevronShortcut = "_qr-6";
export var container = "_qr-1";
export var editor = "_qr-8";
export var editorWrapper = "_qr-7";
export var prefix = "_qr-2";
export var searchIcon = "_qr-3";
export var suffix = "_qr-9";
export var suffixContent = "_qr-a";
export var suffixText = "_qr-b";
export var wrapper = "_qr-0";